import { type BuildAction, type BuildType } from '../context/BuildInfoProvider';

export const getBuildType = (action: BuildAction): BuildType =>
  action.toLowerCase() as BuildType;
